export default function cleanUpAppId(
  appName: string | undefined | null,
): string {
  if (appName === undefined || appName === null) {
    return "";
  }
  return appName.replace(/CLIAPI@\d+(\.\d+)*$/, "");
}
